import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-eye',
  imports: [],
  standalone: true,
  templateUrl: './icon-eye.component.html',
  styleUrl: './icon-eye.component.css',
})
export class IconEyeComponent {

}
